


import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import {
    Grid,
    TextField,
    Button,
    Box,
    Typography,
} from '@mui/material';
import Routes from '../../../routes';
import { trakrefBlue, trakrefDisabledBlue } from '../../../color_utils';
import Select from "../../Common/Select";
import Input from '../../Common/InputField';
import DateInput from '../../Common/DateInput';
import CommonModal from '../../Common/CommonModal';
import toast from 'react-hot-toast';
import CodeConvert from '../../../Utils/DropDownConvert';


const AssignWorkOrderModal = ({ payload, modalOpen, onClose, hasServiceEvent, refreshRequired }) => {
    const [technicians, setTechnicians] = useState([])
    const [serviceCompany, setServiceCompany] = useState([]);
    const [selectedServiceCompany, setSelectedServiceCompany] = useState(null)
    const [primaryTechnician, setPrimaryTechnician] = useState(null);
    const [secondaryTechnician, setSecondaryTechnician] = useState(null);
    const [dateScheduled, setDateScheduled] = useState('');
    const [dueDate, setDueDate] = useState('');
    const [serviceCompanyError, setServiceCompanyError] = useState(null);
    const [dateScheduledError, setDateScheduledError] = useState(null);
    const [allTechs, setAllTechs] = useState(null);
    const [requiredFields, setRequiredFields] = useState(false);

    const [primaryTechError, setPrimaryTechError] = useState(null)


    useEffect(() => {
        const fetchData = async () => {
            const response = await fetch(Routes.WorkOrder.SupportData(payload.ID, payload.LocationID, payload.ServicerID));
            const data = await response.json();
            setAllTechs(data.technicians)
            //var SelectedServiceCompany = data.serviceCompany.filter((obj) => obj.id == payload.ServicerID)
            var SelectedServiceCompany = data.serviceCompany
            setSelectedServiceCompany(payload.ServicerID)
            var ServiceCompanyDropDown = CodeConvert.Convert(SelectedServiceCompany)
            setServiceCompany(ServiceCompanyDropDown)
            const key = 'id'
            let UniqueTechnicians = [...new Map((data.technicians || []).map(item => [item[key], item])).values()]

            //UniqueTechnicians = UniqueTechnicians.filter((obj) => obj.instanceID == payload.ServicerID)

            //console.log(UniqueTechnicians)

            var TechCodes = CodeConvert.ConverUser(UniqueTechnicians)

            console.log(TechCodes)
            setTechnicians(TechCodes.sort((a, b) => a.firstName - b.firstName))


        };
        if (modalOpen == true) {
            fetchData()
        }
    }, [modalOpen])

    useEffect(() => {
        if (selectedServiceCompany == payload.ServicerID) {
            setRequiredFields(true)
        } else {
            setRequiredFields(false)
        }
    }, [selectedServiceCompany])



    var ChangeServiceCompany = async (value) => {
        setSelectedServiceCompany(value)

        const response = await fetch(Routes.WorkOrder.GetServicerTechnicians(payload.LocationID, value))
        const data = await response.json()

        if (data.technicians.length > 0) {
            const key = 'id'
            let UniqueTechnicians = [...new Map(data.technicians.map(item => [item[key], item])).values()]
            var TechCodes = CodeConvert.ConverUser(UniqueTechnicians)
            setTechnicians(TechCodes)
        } else {
            setTechnicians([])
            setPrimaryTechnician(null)
            setSecondaryTechnician(null)
        }
    }


    var Validated = () => {
        //ID and PrimaryTechID are required
        var isValid = true



        if (hasServiceEvent == false && (payload.ServicerID == selectedServiceCompany)) {
            if (primaryTechnician == null || primaryTechnician == undefined) {
                setPrimaryTechError("This field is required")
                isValid = false
            }
            if (!dateScheduled || dateScheduled === '' || dateScheduled === null || dateScheduled === undefined) {
                setDateScheduledError("This field is required")
            }
        }


        if (hasServiceEvent == true && (payload.ServicerID == selectedServiceCompany)) {
            if (primaryTechnician == null || primaryTechnician == undefined) {
                setPrimaryTechError("This field is required")
                isValid = false
            }
            if (!dateScheduled || dateScheduled === '' || dateScheduled === null || dateScheduled === undefined) {
                setDateScheduledError("This field is required")
            }
        }


        if (!selectedServiceCompany) {
            setServiceCompanyError("This field is required")
        }

        //if (!dateScheduled) {
        //    setDateScheduledError("This field is required")
        //}
        //console.log(dateScheduled)

        //return false
        return isValid
    }

    var SaveAssign = async () => {

        if (Validated() == false) {
            console.log("NOT VALID")
            return
        }
        const postConfig = {
            method: "POST",
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({
                ID: payload.ID,
                ServiceCompanyID: selectedServiceCompany,
                PrimaryTechnicianID: primaryTechnician,
                SecondaryTechnicianID: secondaryTechnician,
                DateScheduled: dateScheduled,
                DueDate: dueDate
            })
        }

        var PrintData = {
            ID: payload.ID,
            ServiceCompanyID: selectedServiceCompany,
            PrimaryTechnicianID: primaryTechnician,
            SecondaryTechnicianID: secondaryTechnician,
            DateScheduled: dateScheduled,
            DueDate: dueDate
        }

        const UpdateResponse = await fetch(Routes.WorkOrder.AssignWorkOrder(), postConfig)
        if (UpdateResponse.status == 200) {
            onClose()
            refreshRequired()
            toast.success('The work order has been successfully assigned.', { duration: 6000 });
        }
    }


    return (
        <CommonModal open={modalOpen} close={onClose} header={`Assign Work Order #${payload.ID}`}>
            <Grid container sx={{ px: { xs: 1, sm: 10 } }}>
                <Grid item xs={12} lg={12} mb={1} pt={2} align='center' >
                    <Select
                        label="Service Company"
                        options={serviceCompany}
                        value={selectedServiceCompany}
                        onChange={(e) => ChangeServiceCompany(e.target.value)}
                        error={serviceCompanyError}
                        required
                        disabled={hasServiceEvent}
                        sx={{ width: '100%' }}
                    />
                </Grid>
                <Grid item xs={12} lg={12} mb={1} pt={2} align='center'>
                    <Select

                        label="Scheduled Primary Technician"
                        options={technicians}
                        value={primaryTechnician}
                        error={primaryTechError}
                        onChange={e => setPrimaryTechnician(e.target.value)}
                        required={requiredFields}
                        sx={{ width: '100%' }}
                    />
                </Grid>
                <Grid item xs={12} lg={12} mb={1} pt={2} align='center'>
                    <Select
                        fullWidth
                        label="Scheduled Secondary Technician"
                        value={secondaryTechnician}
                        options={technicians.filter((obj) => obj.value != primaryTechnician)}
                        onChange={e => setSecondaryTechnician(e.target.value)}
                        sx={{ width: '100%' }}
                    />
                </Grid>
                <Grid item xs={12} lg={12} mb={1} pt={2} align='center'>
                    <DateInput

                        allowPast
                        allowFuture
                        date={dateScheduled}
                        onChange={date => setDateScheduled(date)}
                        label={`Date Scheduled ${requiredFields ? '*' : ''}`}
                        error={dateScheduledError}

                    />
                </Grid>
                <Grid item xs={12} lg={12} mb={2} pt={2} align='center'>
                    <DateInput
                        required
                        allowPast
                        allowFuture
                        date={dueDate}
                        onChange={date => setDueDate(date)}
                        label="Due Date"
                    />
                </Grid>
                <Grid item xs={12} lg={12} align='center'>
                    <Box mt={2} mb={2} sx={{ width: '100%' }}>
                        <Button
                            fullWidth
                            size='large'
                            onClick={() => SaveAssign()}
                            variant='contained'
                            style={{
                                backgroundColor: trakrefBlue
                            }}
                        >
                            <Typography sx={{ padding: '1% 0%', color: '#fff', fontSize: 17, fontWeight: 400 }}>
                                ASSIGN WORK ORDER
                            </Typography>
                        </Button>
                    </Box>
                </Grid>

            </Grid>
        </CommonModal>
    );
};


export default AssignWorkOrderModal;
